import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAlumniErrorMessage,
  getLoanDetails,
  getLoanErrorMessage,
  submitAlumni,
} from "../../services/alumniService";

const initialState = {
  status: "idle",
  error: "",
  fieldErrors: {},
  lastSubmission: null,
  loanVerification: {
    status: "idle",
    accountNumber: "",
    loanDate: "",
    error: "",
    requestId: null,
  },
};

export const verifyLoanAccount = createAsyncThunk(
  "alumni/verifyLoanAccount",
  async (loanAccountNumber, { rejectWithValue }) => {
    try {
      return await getLoanDetails(loanAccountNumber);
    } catch (error) {
      return rejectWithValue(getLoanErrorMessage(error));
    }
  }
);

export const sendAlumniForm = createAsyncThunk(
  "alumni/sendAlumniForm",
  async ({ data, educationProof }, { rejectWithValue }) => {
    try {
      const response = await submitAlumni({ data, educationProof });
      return response;
    } catch (error) {
      return rejectWithValue(getAlumniErrorMessage(error));
    }
  }
);

const alumniSlice = createSlice({
  name: "alumni",
  initialState,
  reducers: {
    clearAlumniState: (state) => {
      state.status = "idle";
      state.error = "";
      state.fieldErrors = {};
      state.lastSubmission = null;
      state.loanVerification = { ...initialState.loanVerification };
    },
    clearLoanVerification: (state) => {
      state.loanVerification = { ...initialState.loanVerification };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyLoanAccount.pending, (state, action) => {
        state.loanVerification = {
          status: "loading",
          accountNumber: action.meta.arg,
          loanDate: "",
          error: "",
          requestId: action.meta.requestId,
        };
      })
      .addCase(verifyLoanAccount.fulfilled, (state, action) => {
        if (state.loanVerification.requestId !== action.meta.requestId) {
          return;
        }

        state.loanVerification = {
          status: "succeeded",
          accountNumber: action.payload.loanAccountNumber || action.meta.arg,
          loanDate: action.payload.loanDate,
          error: "",
          requestId: action.meta.requestId,
        };
      })
      .addCase(verifyLoanAccount.rejected, (state, action) => {
        if (state.loanVerification.requestId !== action.meta.requestId) {
          return;
        }

        state.loanVerification = {
          status: "failed",
          accountNumber: action.meta.arg,
          loanDate: "",
          error: action.payload || "This loan account does not exist.",
          requestId: action.meta.requestId,
        };
      })
      .addCase(sendAlumniForm.pending, (state) => {
        state.status = "loading";
        state.error = "";
        state.fieldErrors = {};
      })
      .addCase(sendAlumniForm.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.lastSubmission = action.payload;
      })
      .addCase(sendAlumniForm.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Alumni submission failed.";
      });
  },
});

export const { clearAlumniState, clearLoanVerification } = alumniSlice.actions;
export default alumniSlice.reducer;
